import * as i0 from "@angular/core";
export let UiIconLibrary = /*#__PURE__*/(() => {
  class UiIconLibrary {
    constructor() {
      this.definitions = {};
    }
    addIcons(...icons) {
      for (const icon of icons) {
        if (!(icon.prefix in this.definitions)) {
          this.definitions[icon.prefix] = {};
        }
        this.definitions[icon.prefix][icon.iconName] = icon;
        for (const alias of icon.icon[2]) {
          if (typeof alias === 'string') {
            this.definitions[icon.prefix][alias] = icon;
          }
        }
      }
    }
    getIconDefinition(prefix, name) {
      if (prefix in this.definitions && name in this.definitions[prefix]) {
        return this.definitions[prefix][name];
      }
      return null;
    }
    static {
      this.ɵfac = function UiIconLibrary_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiIconLibrary)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: UiIconLibrary,
        factory: UiIconLibrary.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return UiIconLibrary;
})();